import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var resultsPanel = /*#__PURE__*/css("margin-top:16px;", media('>=tablet'), "{margin-top:33px;}");